import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  // Navigation
  imprintFooterSelector,
  tAndCFooterSelector,
  privacyAtXingFooterSelector,
  privacyPolicyFooterSelector,
  // Props
  localeSelector,
} from '@xingternal/platform-layout-selectors';

const legalLinksSelector = createSelector(
  localeSelector,
  imprintFooterSelector,
  tAndCFooterSelector,
  privacyAtXingFooterSelector,
  privacyPolicyFooterSelector,
  (
    locale,
    imprintFooter,
    tAndCFooter,
    privacyAtXingFooter,
    privacyPolicyFooter
  ) => {
    return [
      imprintFooter,
      tAndCFooter,
      privacyAtXingFooter,
      privacyPolicyFooter,
    ]
      .filter(Boolean)
      .map(localizedLink(locale));
  }
);

export { legalLinksSelector };
